<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> All permissions
          </div>
          <div class="card-block">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Display name</th>
                <th>Description</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="permission in permissions">
                  <td>{{permission.id}}</td>
                  <td>{{permission.name}}</td>
                  <td>{{permission.display_name}}</td>
                  <td>{{permission.description}}</td>
                </tr>
              </tbody>
            </table>
            <!--<nav>-->
              <!--<ul class="pagination">-->
                <!--<li class="page-item"><a class="page-link" href="#">Prev</a></li>-->
                <!--<li class="page-item active">-->
                  <!--<a class="page-link" href="#">1</a>-->
                <!--</li>-->
                <!--<li class="page-item"><a class="page-link" href="#">2</a></li>-->
                <!--<li class="page-item"><a class="page-link" href="#">3</a></li>-->
                <!--<li class="page-item"><a class="page-link" href="#">4</a></li>-->
                <!--<li class="page-item"><a class="page-link" href="#">Next</a></li>-->
              <!--</ul>-->
            <!--</nav>-->
          </div>
        </div>
      </div><!--/.col-->
    </div><!--/.row-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'users',
  computed: {
    ...mapGetters('Identities', [
      'permissions'
    ])
  },
  methods: {
    ...mapActions('Identities', [
      'LOAD_PERMISSIONS'
    ])
  },
  mounted() {
    this.LOAD_PERMISSIONS();
  }
};
</script>
